angular.module('chat2')
    /**
     * This directive fires on the last ng-repeat of the messages repeater
     * The messageId is specified as an attribute and we broadcast this.
     * the  newMessageRendered event is consumed inside the auto-scroll directive
     */
    .directive('onLastRepeat', ["$rootScope", function ($rootScope) {
        return function (scope, element, attrs) {
            if (scope.$last) {
                setTimeout(function () {
                    // this will always be the newest message - but wont be in view if there is a scrollbar ...
                    $rootScope.$broadcast("newMessageRendered", attrs.messageId);
                }, 1);
            }
        };
    }])


    /**
     * This directive will detect a single unselected conversation in the conversation view and load it.
     * The directive hooks into the repeater and runs on the last item. If it's index is zero (i.e only one) and it isn't selected
     * we will navigate into the conversation to display the messages
     */
    .directive('autoLoadSingleConversation',
        ["$state", "$stateParams",
            function ($state, $stateParams) {
                return function (scope, element, attrs) {
                    if (scope.$last && scope.$index === 0) {

                        setTimeout(function () {

                            var active = element.hasClass("active");

                            if (!active) {

                                $state.go("main.apiSpace.chat2.chat.conversation", {
                                    pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                                    id: attrs.id
                                });
                            }
                        }, 1);

                    }
                };
            }]);